import { memo } from "react";
import AdUnit, { AdUnitTypeEnum } from "components/ads/AdUnit";
import { AdUnitsKeys } from "components/ads/config/units";
import { useDeviceType } from "@/common/hooks/useDeviceType";
import { deviceTypeEnum } from "@/common/utils/device";
import { AD_POSITION_FACTOR } from "./utils";

interface IProps {
  position: number;
  mobileAds: AdUnitsKeys[];
  desktopAds: AdUnitsKeys[];
}

export const ScrollAdDispatcher = memo(({ position, mobileAds, desktopAds }: IProps) => {
  const isDesktop = useDeviceType() === deviceTypeEnum.DESKTOP;

  const index = (position / AD_POSITION_FACTOR) - 1;
  const currentAds = isDesktop ? desktopAds : mobileAds;
  const type = isDesktop ? AdUnitTypeEnum.DESKTOP : AdUnitTypeEnum.MOBILE;

  if (!currentAds[index]) {
    return null;
  }

  return <AdUnit name={currentAds[index]} type={type}/>;
});
